import { ClassEnrolment } from "./class-enrolment.model";
import { CourseDTO } from "./course-dto.model";
import { CourseTrainingProgramDetails } from "./course-training-program-details.model";

export class ClassCourseWithEnrolmentsDTO {
    CourseEnrolments : ClassEnrolment[];
    courseDetails :CourseTrainingProgramDetails;
}